import React from 'react';
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { noop } from "@client/shared/constants";

import CloseIcon from "@mui/icons-material/Close";
import Box from '@mui/material/Box';
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import styles from "./style";

const WarningView = ({
  isOpen = false,
  warningMessage = '',
  onClose = noop
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle sx={styles.dialogTitle}>
        <IconButton onClick={onClose}>
          <CloseIcon sx={{ color: '#B0B0B0' }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Box sx={{ mt: 2 }}>
          <img height={116} alt="Alert Icon" src="/assets/error-icon.svg" />
        </Box>
        {/* <WarningRoundedIcon
          fontSize="large"
          color="error"
          sx={styles.infoBtn}
        /> */}
        <Typography variant="h4" sx={styles.heading}>
          Feature Disabled
        </Typography>
        {warningMessage && <Typography sx={{ mt: 2, textAlign: 'center' }} variant="body1">{warningMessage}</Typography>}
      </DialogContent>
      <DialogActions sx={styles.actions}>
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          sx={styles.actionButtons}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WarningView
